import { boolean, intersect, nullable, partial, string, struct } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../organization/Id';

import { Id } from './Id';

export const RefItem = intersect(
	struct({
		id: Id,
	})
)(
	partial({
		name: string,
		jobRef: nullable(string),

		organizationId: OrganizationId,

		isDeleted: boolean,
		/** [ROME-125] the job (or the transaction's job) is soft or deep archived: read-only */
		isArchived: boolean,
	})
);
